import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { setConditionField } from 'actions/feature/conditions'
import EdgeEditor from './EdgeEditor'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { uri } = ownProps

    const { edge } = conditionSelector(state, {
      queryUri: uri,
    })

    return {
      edge,
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { uri } = ownProps

  return {
    onEdgeChange: (event) => {
      dispatch(setConditionField(uri, 'edge', event.target.value))
    },
  }
}

const EdgeEditorContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(EdgeEditor)

export default EdgeEditorContainer
